export const measurementServiceIds = {
  INTERIOR_DOORS: '2077',
  LAMINATE: '6854',
};
